import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'

import { PriceLevelData } from 'app/models'

import { MembershipDefinition } from 'app/models'

import { CartService } from './cart.service'
import { MembershipDefinitionPricing } from './membership-definition.service'

@Injectable({
  providedIn: 'root'
})
export class MembershipPricingService {
  public customerPaysFee: boolean

  constructor(private cartService: CartService) { }

  public getPricing(memdef: MembershipDefinition, personaId: number): Observable<MembershipDefinitionPricing> {
    const orgId = memdef.boss_organization_id
    const data = [{ persona_ids: [personaId], membership_definition_id: memdef.id }]
    return this.cartService.evaluatePricingRules(orgId, data)
      .pipe(first())
      .pipe(map(response => {
        const result = (response.result || [])[0] || { }
        this.customerPaysFee = result.customer_pays_fee
        const priceData: PriceLevelData[] = ((result || { }).price_level_data) || []
        const personaPriceData = priceData.find(pd => (pd.persona_ids || []).includes(personaId))
        const price = personaPriceData ? personaPriceData.price_cents / 100 : memdef.price
        return { membership_definition_id: memdef.id, price: price, customer_pays_fee: this.customerPaysFee }
      }))
  }
}
